/** By default pages require auth. */
export const DEFAULT_PAGES_REQUIRE_AUTH = true;

export const AWS_VISIT_IMAGE_URL_PREFIX = `${process.env.NEXT_PUBLIC_AWS_IMAGE_URL}/`;
export const VISIT_REPORT_URL = "https://reporting.vergo.uk/Gateway/GetVisitReportPDF?ImageQuality=85";
// export const REPORT_URL = "https://reporting.vergo.uk/ePest/GetReport";
export const HEALTH_AND_SAFETY_URL = "https://vergopestalert.blob.core.windows.net/healthandsafety/";
export const SITE_PLAN_URL_PREFIX = `${process.env.NEXT_PUBLIC_EXT_API_URL}/files/`;
export const PDF_USER_GUIDE = "https://vergopestalert.blob.core.windows.net/hub/Vergo%20Hub%20-%20User%20Guide.pdf";
export const VIDEO_USER_GUIDE = "https://player.vimeo.com/video/809137687";

export const SESSION_COOKIE_LIFE = 14; // Days

// Renamed from the previous "vergo-session" - unprefixed, it collided with
// vergo-auth-fe's equivalent cookie since both apps run on `localhost` in
// dev and cookies ignore port.
export const SESSION_COOKIE_NAME = "vergo-hub-session";
